// extracted by mini-css-extract-plugin
export default {"badge":"breadcrumb-badge_badge__LozIq","red":"breadcrumb-badge_red__o7KuW","gray":"breadcrumb-badge_gray__v-UKI","white":"breadcrumb-badge_white__mdutE"};